// import { createStore, applyMiddleware, compose } from 'redux';
// import thunk from 'redux-thunk';
// import { routerMiddleware } from 'connected-react-router';
// import history from './history';
// import rootReducer from './rootReducer';
// import { persistStore, persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';

// const router = routerMiddleware(history);

// // NOTE: Do not change middleares delaration pattern since rekit plugins may register middlewares to it.
// const refreshMiddleware = (({ dispatch, getState }) => {
//   return (next) => (action) => {
//     return next(action);
//   };
// });

// const middlewares = [refreshMiddleware, thunk, router];

// const rootPersistConfig = {
//   key: 'root',
//   storage,
//   whitelist: ['home']
// };

// const reducer = persistReducer(rootPersistConfig, rootReducer);

// let devToolsExtension = f => f;

// /* istanbul ignore if  */
// if (process.env.NODE_ENV === 'development') {
//   const { createLogger } = require('redux-logger');

//   const logger = createLogger({ collapsed: true });
//   middlewares.push(logger);

//   if (window.__REDUX_DEVTOOLS_EXTENSION__) {
//     devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__();
//   }
// }

// const configureStore = (initialState) => {
//   const store = createStore(
//     reducer,
//     initialState,
//     compose(
//       applyMiddleware(...middlewares),
//       devToolsExtension,
//     ),
//   );

//   /* istanbul ignore if  */
//   if (module.hot) {
//     // Enable Webpack hot module replacement for reducers
//     module.hot.accept('./rootReducer', () => {
//       const nextRootReducer = require('./rootReducer').default; // eslint-disable-line
//       store.replaceReducer(nextRootReducer);
//     });
//   }
//   const persistor = persistStore(store);
//   return { store, persistor };
// }

// export default configureStore;


import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import history from './history';
import rootReducer from './rootReducer';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const router = routerMiddleware(history);

// NOTE: Do not change middleares delaration pattern since rekit plugins may register middlewares to it.
const refreshMiddleware = (({ dispatch, getState }) => {
  return (next) => (action) => {
    return next(action);
  };
});

const middlewares = [refreshMiddleware, thunk, router];

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: ['home']
};

const reducer = persistReducer(rootPersistConfig, rootReducer);

let devToolsExtension = f => f;

/* istanbul ignore if  */
if (process.env.NODE_ENV === 'development') {
  const { createLogger } = require('redux-logger');

  const logger = createLogger({ collapsed: true });
  middlewares.push(logger);

  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__();
  }
}

const configureStore = (initialState) => {
  const store = createStore(
    reducer,
    initialState,
    compose(
      applyMiddleware(...middlewares),
      devToolsExtension,
    ),
  );

  /* istanbul ignore if  */
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./rootReducer', () => {
      const nextRootReducer = require('./rootReducer').default; // eslint-disable-line
      store.replaceReducer(nextRootReducer);
    });
  }
  const persistor = persistStore(store);
  return { store, persistor };
}

export default configureStore;
export const configureStoreInstance = configureStore(); // creates the singleton at module load
export const { store, persistor } = configureStoreInstance;


